'use client';

import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

export const BackgroundBeams = ({ className = '' }: { className?: string }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-rose-100/20 via-rose-200/20 to-transparent 
                    dark:from-rose-950/20 dark:via-rose-900/20 dark:to-transparent" />
      
      {/* Animated beams */}
      <div className="absolute inset-0">
        {/* Vertical beams */}
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={`beam-${i}`}
            initial={{ opacity: 0, height: '0%' }}
            animate={{ 
              opacity: [0.4, 0.8, 0.4],
              height: '100%',
              transition: {
                opacity: {
                  duration: 3,
                  repeat: Infinity,
                  delay: i * 0.3,
                },
                height: {
                  duration: 2,
                  delay: i * 0.2,
                }
              }
            }}
            className="absolute bottom-0 w-[1px] bg-gradient-to-b from-transparent via-rose-500/40 to-transparent"
            style={{ left: `${20 + i * 15}%` }}
          />
        ))}

        {/* Horizontal beams */}
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={`h-beam-${i}`}
            initial={{ opacity: 0, width: '0%' }}
            animate={{ 
              opacity: [0.3, 0.6, 0.3],
              width: '100%',
              transition: {
                opacity: {
                  duration: 4,
                  repeat: Infinity,
                  delay: i * 0.5,
                },
                width: {
                  duration: 2.5,
                  delay: i * 0.3,
                }
              }
            }}
            className="absolute left-0 h-[1px] bg-gradient-to-r from-transparent via-rose-500/40 to-transparent"
            style={{ top: `${30 + i * 20}%` }}
          />
        ))}

        {/* Glowing orbs */}
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={`orb-${i}`}
            className="absolute w-32 h-32 bg-rose-500/30 rounded-full blur-3xl"
            initial={{ x: -100, y: -100 }}
            animate={{
              x: [0, 100, 0],
              y: [0, 100, 0],
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.6, 0.3],
            }}
            transition={{
              duration: 10,
              delay: i * 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              left: `${20 + i * 30}%`,
              top: `${20 + i * 20}%`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
